export default [
    { label: 'SubCategory Name', name: 'name' },
    { label: 'Description', name: 'description'}
];